import { render, staticRenderFns } from "./FragebogenRoot.vue?vue&type=template&id=eba1664c&scoped=true"
import script from "./FragebogenRoot.vue?vue&type=script&lang=js"
export * from "./FragebogenRoot.vue?vue&type=script&lang=js"
import style0 from "./FragebogenRoot.vue?vue&type=style&index=0&id=eba1664c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba1664c",
  null
  
)

export default component.exports